import _round from "lodash.round";
import { getApiRole } from "lib/general-helper.js";

function cleanObjectives(data) {
  let objectives = {};
  let objectivesData = data[0];
  const last_updated = data[1];
  const total_matches = data[2];

  for (const [role, roleData] of Object.entries(objectivesData)) {
    let role_array = [];
    roleData.forEach((champInfo) => {
      // const champion_id = champInfo[0];
      const matches = champInfo[2];

      const cur_champ_info = {
        role,
        champion_id: champInfo[0],
        champion_link: {
          champion_id: champInfo[0],
          role,
        },
        wins: champInfo[1],
        matches,
        win_rate: _round((champInfo[1] / matches) * 100, 2),
        pick_rate: _round((matches / total_matches) * 100, 2),
        gold: _round(champInfo[3] / matches, 0),
        cs: _round(champInfo[4] / matches, 1),
        jungle_cs: _round(champInfo[5] / matches, 1),
        enemy_jungle_cs: _round(champInfo[6] / matches, 1),
        turrets: _round(champInfo[7] / matches, 1),
        damage_to_turrets: _round(champInfo[8] / matches, 0),
        wards_killed: _round(champInfo[9] / matches, 1),
        match_duration: _round(champInfo[10] / matches / 60, 2),
      };

      role_array.push(cur_champ_info);
    });

    let sorted_role_array = role_array.sort((a, b) => {
      // Sort by Win Rate
      return b.win_rate - a.win_rate;
    });

    objectives[role] = sorted_role_array;
  }

  let all_roles_array = [];
  for (const [role, roleData] of Object.entries(objectives)) {
    all_roles_array = all_roles_array.concat(roleData);
  }
  let sorted_roles_array = all_roles_array.sort((a, b) => {
    // Sort by Win Rate
    return b.win_rate - a.win_rate;
  });

  objectives["all"] = sorted_roles_array;

  let ret_data = {
    objectives,
    last_updated,
    total_matches,
  };

  return ret_data;
}

// const arrAvg = arr => arr.reduce((a, b) => a + b, 0) / arr.length;

// eventually need to refactor this code
function cleanChampionTableData(winRate, queueType, apiRole) {
  let cleaned = {};
  if (winRate) {
    if (queueType === "normal_aram" || queueType == "nexus_blitz") {
      cleaned.roleChampionWinRates = winRate.win_rates["none"];
      cleaned.totalMatchesCount = Math.floor(winRate.total_matches / 10);
    } else {
      cleaned.roleChampionWinRates = winRate.win_rates[apiRole];
      cleaned.totalMatchesCount = Math.floor(winRate.total_matches / 2);
    }
    cleaned.lastUpdated = winRate.last_updated_at;
  }

  return cleaned;
}

function getWinRatesIndex(params) {
  return `${[params.region, params.queueType, params.patch, params.rank].join("_")}`;
}

function selectObjectivesData(objectivesData, params) {
  let objectives, last_updated, total_matches;

  if (!objectivesData) {
    return { objectives, last_updated, total_matches };
  }

  let { queueType, role } = params;

  if (queueType === "normal_aram" || queueType == "nexus_blitz") {
    role = "none";
  } else {
    role = getApiRole(role);
  }

  // let curWinRate = winRates[getWinRatesIndex(params)];

  if (objectivesData) {
    objectives = objectivesData.objectives[role];
    last_updated = objectivesData.last_updated;
    total_matches = objectivesData.total_matches;
  }

  return { objectives, last_updated, total_matches };
}

export { cleanObjectives, cleanChampionTableData, selectObjectivesData, getWinRatesIndex };
